<template>
  <div class="w100 pt20 pb20 pl20 pr20 bg-w" v-loading="loading">
    <el-tabs v-model="activeName">
      <el-tab-pane label="修改密码" name="0">
        <div class="w100 mt20 flex-box al-c">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
          >
            <el-form-item label="旧密码" prop="oldPassword">
              <el-input
                type="password"
                v-model="ruleForm.oldPassword"
                placeholder="请输入原来的密码"
                show-password
                clearable
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input
                type="password"
                v-model="ruleForm.newPassword"
                placeholder="请输入新密码"
                show-password
                clearable
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPassword">
              <el-input
                type="password"
                v-model="ruleForm.checkPassword"
                placeholder="请再次输入新密码"
                show-password
                clearable
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm()">提交</el-button>
              <el-button @click="resetForm()">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="账号历史" name="1">
        <el-table
          v-loading="tableLoading"
          :data="tableData.data"
          stripe
          height="100%"
          style="min-width: 100%; min-height: 100%"
          tooltip-effect="dark"
          header-row-class-name="table-head"
          ref="deptTable"
        >
          <el-table-column
            prop="remoteAddr"
            align="center"
            label="IP"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            label="时间"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="deptName"
            align="center"
            label="部门"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="title"
            align="center"
            label="结果"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { passwordEdit, getLogData } from "@/api/personalCenter/personalInfo";

export default {
  name: "PasswordEdit",
  components: {},
  props: [],
  data() {
    let validatePass = (rule, value, callback) => {
      let reg =
        /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{6,}$/;
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error("两次输入的新密码不一致!"));
      } else if (!reg.test(value)) {
        callback(new Error("密码包含数字,大小写,特殊字符中三种"));
      } else {
        callback();
      }
    };
    let checkNewPassword = (rule, value, callback) => {
      let reg =
        /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{6,}$/;
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码包含数字,大小写,特殊字符中三种"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      activeName: "0",
      tableLoading: false,
      tableData: {
        data: [],
        total: 0,
      },
      rules: {
        oldPassword: [
          { required: true, message: "请输入原来的密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
          { validator: checkNewPassword, trigger: "blur" },
        ],
        checkPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
          { validator: validatePass, trigger: "blur" },
        ],
      },
      ruleForm: {
        oldPassword: "",
        newPassword: "",
        checkPassword: "",
      },
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getLog();
  },
  destroyed() {},
  methods: {
    handlePasswordEdit() {
      this.loading = true;
      let params = {
        oldPassword: this.ruleForm.oldPassword,
        newPassword: this.ruleForm.newPassword,
        userId: this.$store.getters.userData.userId,
      };
      passwordEdit(params)
        .then(({ data }) => {
          this.loading = false;
          if (data.code == 0) {
            this.$message.success("修改密码成功！");
            const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
            userData.firstLogin = "1";
            sessionStorage.setItem("userData", JSON.stringify(userData));
            this.$store.dispatch("setUserData", userData);
            this.$router.push("/");
          } else {
            this.$message.warning(data.msg || "修改密码失败！");
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          //密码八位以上，数字，大小写，特殊字符中包含三种
          // let reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,}$/;
          // if(reg.test(this.ruleForm.newPassword)){
          this.handlePasswordEdit();
          // }
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    //获取用户登录历史数据
    getLog() {
      let params = {
        classicType: "login",
        uids: this.$store.getters.userData.userName || "",
        current: 1,
        size: 10,
      };
      getLogData(params)
        .then(({ data }) => {
          if (data.code == 0) {
            this.tableData.data = data.data.records || [];
          } else {
            this.$message.warning(data.msg || "获取数据异常");
          }
        })
        .catch(err => {
          this.$message.error(data.msg || "获取数据异常!");
        });
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="less">
/deep/.el-tabs__item.is-active {
  color: #064576;
}
/deep/.el-tabs__active-bar {
  background-color: #064576;
}
/deep/#tab-bpmnPageProcess {
  width: 80px;
  text-align: center;
}
</style>
